$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    var coc = false;
    if ($(this).attr('data-mode-champs') == 'true'){
      coc = true;
    }
    if( coc == false){
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");
      if (mode == "sub") {
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: currentSellingPlan,
        };
      } else {
        data = {
          id: currentId,
          quantity: 1,
        };
      }

      console.log(data);

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {},
        error: function () {
          // alert("Error adding item to the cart.");
        },
      });
    }
    else{
      var mode = $(".product-selector_outer.active_block").attr("data");
      var $activeOuter = $(".product-selector_outer.active_block");
      var $activeBox = $activeOuter.find(".product-selector_block.active");

      // 1, 2, or 3
      var selectedOrder = $activeBox.index() + 1;

      var $config = $(".mp_coc_config--data");

      var domain = $config.attr("data-url");

      // gets data-id-1 / data-id-2 / data-id-3 dynamically
      if (mode == 'sub' ){
        var productId = $config.attr("data-id-sub-" + selectedOrder);
      }
      else{
        var productId = $config.attr("data-id-" + selectedOrder);
      }
      

      var newUrl = domain + "?products=" + productId;

      console.log(newUrl);

      window.location.href = newUrl;

    }

    
  });
});
